import RootReducer from '../reducers';
import { createLogger } from 'redux-logger';
import {configureStore} from "@reduxjs/toolkit";

const loggerMiddleware = createLogger();

export const store = configureStore({
    reducer: RootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(loggerMiddleware),
})

export function getStore() {
    return store;
}
